import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { App } from './App';
import * as serviceWorker from './serviceWorker';
import Backend from 'i18next-http-backend';
import Loader from './components/Loader/Loader';
import { initDatadog } from './services/datadog';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

// Initialize Datadog RUM as early as possible
initDatadog();


i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    debug: true,
    ns: ['common', 'habitation', 'rc', 'sante-mobilite'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

const tagManagerArgs = {
  gtmId: 'GTM-KBD39ZT9'
};
TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
